import React, { FC } from "react";
import { Button } from "@mui/material";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import Menu from "@mui/material/Menu";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

import { useTranslation } from "react-i18next";
import { SwitchesStyles } from "./ColumnSwitchesStyles";
import Switches from "./switches/Switches";
import { ButtonMenuDataTableProps } from "../export/ExportButton";

const ColumnSwitches: FC<ButtonMenuDataTableProps> = ({
  loading,
  disabled = false,
}) => {
  const [t] = useTranslation("global");
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <Button
            disabled={loading || disabled}
            variant="outlined"
            startIcon={<ViewColumnIcon />}
            sx={SwitchesStyles.SwitchesButton}
            {...bindTrigger(popupState)}
          >
            {t("Data.Display")}
          </Button>
          <Menu {...bindMenu(popupState)} sx={SwitchesStyles.Menu}>
            <div className="columns-container-switches">
              <Switches t={t} />
            </div>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
};

export default ColumnSwitches;
